/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'usb-drive': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M6 .5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v4H6zM7 1v1h1V1zm2 0v1h1V1zM6 5a1 1 0 00-1 1v8.5A1.5 1.5 0 006.5 16h4a1.5 1.5 0 001.5-1.5V6a1 1 0 00-1-1zm0 1h5v8.5a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5z"/>',
    },
});
